import React, { useEffect, useMemo, useState } from 'react';
import MaterialTable from 'material-table';
import { styledTable, styledTableHeading, tableIcons } from '../../../helpers';
import useAPI from '../../../hooks/useAPI';
import {
  localization, modifyDefaultOptions, options, tableIconsModified,
} from '../../../helpers/table';
import { useAPICostAgreements } from '../adminApiService';
import Select from "react-select";

export default function TabCostAgreements() {
  const [isLoaded, setIsLoaded] = useState(false);
  const [data, setData] = useState([]);
  const [agreements, setAgreements] = useState([]);

  const api = useAPI();
  const [getData, saveData, removeData] = useMemo(
    () => useAPICostAgreements(api),
    [api],
  );

  useEffect(async () => {
    const result = await getData();

    const respAgrs = await api.get('/mng/agreements');
    if (respAgrs && !respAgrs.error) {
      setAgreements(respAgrs);
    }

    setIsLoaded(true);
    setData(result);
  }, []);

  const handleSaveData = async (entry) => {
    const resp = await saveData(entry);
    if (!resp || resp.error) return null;
    return resp;
  };

  const handleRemoveData = async (entry) => {
    const resp = await removeData(entry);
    if (!resp || resp.error) return null;
    return resp;
  };

  const mapAgrsToOptions = (agrs) => agrs ? agrs.map(a => ({ label: a.num, value: a.id })) : [];
  const onAgrMultiselectChange = (selectedOptions, onChangeHandler) => {
    const newVals = agreements.filter(a => selectedOptions.map(sO => sO.value).includes(a.id));
    onChangeHandler(newVals);
  };

  const columns = [
    {
      title: 'Код',
      field: 'num',
      maxWidth: 100,
      filterCellStyle: { minWidth: '60px' },
    },
    {
      title: 'Наименование статьи затрат (Соглашение)',
      field: 'name',
      filterCellStyle: { minWidth: '300px' },
    },
    {
      title: 'Соглашения',
      field: 'agreements',
      filterCellStyle: { minWidth: '80%' },
      lookup: arrayToLookup("num", agreements),
      render: (rowData) => (
        <div style={{ whiteSpace: "pre-wrap" }}>{rowData.agreements.map((a) => a.num).join("\n")}</div>
      ),
      customFilterAndSearch: (term, rowData) => {
        if (term.length == 0) return true;
        const agreement = rowData.agreements.map((e) => e.num);
        const res = term.filter((x) => agreement.includes(x));
        return res.length > 0;
      },
      editComponent: ({ rowData, value, onChange }) => (<Select
          placeholder=""
          isMulti
          menuPlacement="auto"
          options={mapAgrsToOptions(agreements)}
          onChange={(selValues) => onAgrMultiselectChange(selValues, onChange)}
          value={mapAgrsToOptions(value)}
          closeMenuOnSelect={false}
          components={{ IndicatorSeparator:() => null, ClearIndicator: () => null }}
          menuPortalTarget={document.body}
          styles={selectStyles}
      />)
    },
  ];

  if (!isLoaded) {
    return (
      <section className="tab-agreement-plan">
        <div>Загрузка...</div>
      </section>
    );
  } else
    return (
      <section className="tab-statement-events">
        <div style={styledTable}>
          <MaterialTable
          components={{
              Container: (props) => <div className="special-filter-noWidth" {...props} />,
            }}
            title={
              <h3 style={styledTableHeading}>Статьи затрат (Соглашение)</h3>
            }
            options={modifyDefaultOptions({
              actionsColumnIndex: -1,
              addRowPosition: 'first',
              search: false,
            })}
            icons={tableIconsModified}
            editable={{
              onRowAdd: (newData) =>
                new Promise(async (resolve, reject) => {
                  // setData([...data, newData]);
                  const resp = await handleSaveData(newData);
                  if (resp) await setData((prev) => [resp, ...prev]);
                  resolve();
                }),
              onRowUpdate: (newData, oldData) =>
                new Promise(async (resolve, reject) => {
                  const resp = await handleSaveData(newData);
                  if (resp)
                    await setData((prev) =>
                      prev.map((v) => (v.id === resp.id ? resp : v)),
                    );
                  resolve();
                }),
              onRowDelete: (oldData) =>
                new Promise(async (resolve, reject) => {
                  const resp = await handleRemoveData(oldData);
                  if (resp)
                    await setData((prev) =>
                      prev.filter((v) => v.id !== oldData.id),
                    );
                  resolve();
                }),
            }}
            localization={localization}
            columns={columns}
            data={data}
          />
        </div>
      </section>
    );
}

const selectStyles = {
  valueContainer: (provided) => ({...provided, flexDirection: 'column', alignItems: 'flex-start'}),
  multiValue: (provided) => ({...provided, flexDirection: 'row-reverse' }),
  multiValueLabel: (provided) => ({...provided, whiteSpace: undefined }),
  menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
}

const arrayToLookup = (key, values) => {
  if (!values) return {};
  const filteredValues = values.filter((e) => e[key])
  if (filteredValues.length === 0) return false
  return Object.fromEntries(
      filteredValues
      .sort((a, b) => {
        return a[key] === b[key] ? 0 : a[key] < b[key] ? -1 : 1;
      })
      .map((v) => [v[key], v[key || key]])
  );
};
